<template>
	<action-card
		v-if="forms.length"
		:title="$t('nav.forms')"
		icon="clipboard-list"
		:count="forms.length"
		@open="$router.push('/forms')"
	>
		<button v-for="form in visibleForms" :key="form.id" type="button" class="portal-action-row" @click="openRequest(form)">
			<span class="action-row-copy">
				<strong>{{ form.name }}</strong>
				<small>{{ DateTime.fromISO(form.sentTimestamp).toLocaleString(DateTime.DATETIME_SHORT) }}</small>
			</span>
			<portal-icon name="chevron-right" :size="18"></portal-icon>
		</button>
	</action-card>
</template>

<script>
	import { DateTime } from 'luxon';
	import FormRequestViewer from '@/modules/forms/FormRequestViewer';
	import ActionCard from '@/modules/welcome/actionItems/ActionCard';

	export default {
		name: 'Forms',

		props: ['forms'],

		components: { ActionCard },

		data() {
			return { DateTime };
		},

		methods: {
			openRequest(request) {
				this.$store.state.globalModalController
					.openModal(FormRequestViewer, { request }, true, true)
					.then((result) => {
						if (result) this.$emit('refresh');
					});
			},
		},

		computed: {
			visibleForms() {
				return this.forms.slice(0, 5);
			},
		},
	};
</script>
